const PREMIUM = {
  name: 'Store+',
}

export default PREMIUM
